import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  userId: string;
};

export const resetUser2FA = async (scope: RequestScope, { userId }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<any>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<any>>(
      `/organization/user_reset2fa/${userId}?delete_previous=true`,
      undefined,
      options
    );
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
